import { useState, useEffect } from "react";
import { Box, Heading, Text, Spinner, Flex } from "@chakra-ui/react";
import { SearchResults } from "../components/SearchResults";
import type { SearchResult as SearchResultType } from "../interfaces";
import { search } from "../api-client";

export function SearchPage() {
  const [results, setResults] = useState<SearchResultType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const q = searchParams.get("q") || "";
    const category = searchParams.get("category") || "All";
    setQuery(q);

    if (q.trim() === "") {
      setResults([]);
      setLoading(false);
      return;
    }

    const fetchResults = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await search(q, category) as SearchResultType[];
        setResults(data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
    // Keying the component in App.tsx will handle re-fetching on URL change
  }, []);

  return (
    <Box w="full" mb={8}>
      <Heading as="h1" size="2xl" mb={4}>
        Search Results for "{query}"
      </Heading>

      {loading ? (
        <Flex justify="center" my={4}>
          <Spinner size="xl" />
        </Flex>
      ) : error ? (
        <Text color="red.500" my={4} textAlign="center">
          {error}
        </Text>
      ) : results.length === 0 ? (
        <Text my={4} textAlign="center" color="gray.500">
          No results found.
        </Text>
      ) : (
        <Box mt={4} borderWidth="1px" borderRadius="md">
          <SearchResults results={results} />
        </Box>
      )}
    </Box>
  );
}
